module.exports = __webpack_public_path__ + "img/logo.fe8fbf8f.png";